/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";


/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";

/* Styles */
import styles from "./styles";

const DeltaTermsModal = ({showModal, setShowModal, handleAdd}) => {
  const classes = styles({});

  return (
      <UCModal
        className={classes.deltaTermsModal}
        showModal={ showModal }
        setShowModal={ setShowModal }
        modalTitle={ <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.title"/> }
        modalContent={ <Content setShowModal={setShowModal} handleSubmit={handleAdd} /> }
        dataTestId="deltaTermsModal"
      />
  )
}

export default DeltaTermsModal;
